// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.roundTypePicker {
  text-align: left;
}

.roundTypePickerHeading {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.1rem;
  margin: 0 0 0.65rem;
}

.roundTypePickerList {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.roundTypeOption {
  position: relative;
  display: flex;
}

.roundTypeOption label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 0.92rem;
  line-height: 1.2;
  padding: 0.38rem 0.85rem;
  border-radius: var(--pill-radius);
  color: var(--disabled);
  background: var(--white);
  border: 2px dashed var(--ink-faint);
  box-shadow: none;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
  box-sizing: border-box;
  transform: rotate(var(--tilt, 0deg));
  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease,
    border-style 0.12s ease, box-shadow 0.12s ease, transform 0.12s ease;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

.roundTypeOption label:hover {
  transform: translateY(-1px) rotate(var(--tilt, 0deg));
  color: var(--ink-soft);
  border-color: rgba(20, 42, 102, 0.32);
}

.roundTypeOption label[data-format="multiple_choice"] {
  --tilt: -2.5deg;
}

.roundTypeOption label[data-format="free_input"] {
  --tilt: 2.2deg;
}

.roundTypeOption label[data-format="slider"] {
  --tilt: -1.8deg;
}

.roundTypeOption label[data-format="drawing"] {
  --tilt: 2.6deg;
}

.roundTypeOption input[type="checkbox"] {
  appearance: none;
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;
  min-width: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: none;
  box-shadow: none;
  pointer-events: none;
}

.roundTypeOption input[type="checkbox"]:checked + label {
  color: var(--ink);
  border-style: solid;
  border-color: transparent;
  box-shadow: 0 2px 0 rgba(14, 36, 99, 0.12);
}

.roundTypeOption input[type="checkbox"]:checked + label:hover {
  color: var(--ink);
}

.roundTypeOption input[type="checkbox"]:checked + label[data-format="multiple_choice"] {
  background: var(--sky);
}

.roundTypeOption input[type="checkbox"]:checked + label[data-format="free_input"] {
  background: var(--pink-soft);
}

.roundTypeOption input[type="checkbox"]:checked + label[data-format="slider"] {
  background: var(--sky-strong);
}

.roundTypeOption input[type="checkbox"]:checked + label[data-format="drawing"] {
  background: linear-gradient(135deg, var(--sky) 0%, var(--pink-soft) 100%);
}

.roundTypeOption input[type="checkbox"]:focus-visible + label {
  outline: 2px solid var(--navy);
  outline-offset: 2px;
}

.roundTypeHint {
  margin: 0.65rem 0 0;
  font-family: var(--font-body);
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--error-color);
  text-align: center;
}

.roundTypePicker.stacked .roundTypePickerHeading {
  font-size: 1.05rem;
}

.roundTypePicker.stacked .roundTypePickerList {
  gap: 0.5rem;
}

.roundTypePicker.stacked .roundTypeOption label {
  font-size: 1rem;
  padding: 0.48rem 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .roundTypeOption label,
  .roundTypeOption label:hover {
    transition: none;
    transform: rotate(var(--tilt, 0deg));
  }
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/room/shared/round-type-picker.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,iCAAiC;EACjC,sBAAsB;EACtB,wBAAwB;EACxB,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,oCAAoC;EACpC;wEACsE;EACtE,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;EACrD,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE;;IAEE,gBAAgB;IAChB,oCAAoC;EACtC;AACF","sourcesContent":[".roundTypePicker {\n  text-align: left;\n}\n\n.roundTypePickerHeading {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.1rem;\n  margin: 0 0 0.65rem;\n}\n\n.roundTypePickerList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n}\n\n.roundTypeOption {\n  position: relative;\n  display: flex;\n}\n\n.roundTypeOption label {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 0.92rem;\n  line-height: 1.2;\n  padding: 0.38rem 0.85rem;\n  border-radius: var(--pill-radius);\n  color: var(--disabled);\n  background: var(--white);\n  border: 2px dashed var(--ink-faint);\n  box-shadow: none;\n  cursor: pointer;\n  text-align: center;\n  white-space: nowrap;\n  box-sizing: border-box;\n  transform: rotate(var(--tilt, 0deg));\n  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease,\n    border-style 0.12s ease, box-shadow 0.12s ease, transform 0.12s ease;\n  -webkit-tap-highlight-color: transparent;\n  user-select: none;\n}\n\n.roundTypeOption label:hover {\n  transform: translateY(-1px) rotate(var(--tilt, 0deg));\n  color: var(--ink-soft);\n  border-color: rgba(20, 42, 102, 0.32);\n}\n\n.roundTypeOption label[data-format=\"multiple_choice\"] {\n  --tilt: -2.5deg;\n}\n\n.roundTypeOption label[data-format=\"free_input\"] {\n  --tilt: 2.2deg;\n}\n\n.roundTypeOption label[data-format=\"slider\"] {\n  --tilt: -1.8deg;\n}\n\n.roundTypeOption label[data-format=\"drawing\"] {\n  --tilt: 2.6deg;\n}\n\n.roundTypeOption input[type=\"checkbox\"] {\n  appearance: none;\n  position: absolute;\n  opacity: 0;\n  width: 1px;\n  height: 1px;\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: none;\n  box-shadow: none;\n  pointer-events: none;\n}\n\n.roundTypeOption input[type=\"checkbox\"]:checked + label {\n  color: var(--ink);\n  border-style: solid;\n  border-color: transparent;\n  box-shadow: 0 2px 0 rgba(14, 36, 99, 0.12);\n}\n\n.roundTypeOption input[type=\"checkbox\"]:checked + label:hover {\n  color: var(--ink);\n}\n\n.roundTypeOption input[type=\"checkbox\"]:checked + label[data-format=\"multiple_choice\"] {\n  background: var(--sky);\n}\n\n.roundTypeOption input[type=\"checkbox\"]:checked + label[data-format=\"free_input\"] {\n  background: var(--pink-soft);\n}\n\n.roundTypeOption input[type=\"checkbox\"]:checked + label[data-format=\"slider\"] {\n  background: var(--sky-strong);\n}\n\n.roundTypeOption input[type=\"checkbox\"]:checked + label[data-format=\"drawing\"] {\n  background: linear-gradient(135deg, var(--sky) 0%, var(--pink-soft) 100%);\n}\n\n.roundTypeOption input[type=\"checkbox\"]:focus-visible + label {\n  outline: 2px solid var(--navy);\n  outline-offset: 2px;\n}\n\n.roundTypeHint {\n  margin: 0.65rem 0 0;\n  font-family: var(--font-body);\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--error-color);\n  text-align: center;\n}\n\n.roundTypePicker.stacked .roundTypePickerHeading {\n  font-size: 1.05rem;\n}\n\n.roundTypePicker.stacked .roundTypePickerList {\n  gap: 0.5rem;\n}\n\n.roundTypePicker.stacked .roundTypeOption label {\n  font-size: 1rem;\n  padding: 0.48rem 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .roundTypeOption label,\n  .roundTypeOption label:hover {\n    transition: none;\n    transform: rotate(var(--tilt, 0deg));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
